import { trackMgmEvent } from "../../common/events";
import { expressQuerySelector, expressQuerySelectorAll } from "../../common/html";
import { createCollapsable } from "../molecules/collapsable";
import { initTooltip } from "../molecules/tooltip";
import { CreateAndStartLoginWatcher } from "../technical/login-check";
import { CreateLoginRegisterComponents } from "../technical/login-register";
import { createGeneralPageEventsAndComponents } from "../technical/page-general";

window.addEventListener("DOMContentLoaded", async () => {
	createGeneralPageEventsAndComponents();
	CreateLoginRegisterComponents(false);
	await CreateAndStartLoginWatcher();

	const linkEl = expressQuerySelector<HTMLElement>(document, ".technical-share-link", false);
	const shareLinkEL = expressQuerySelector<HTMLElement>(document, ".technical-copy-link", false);
	const shareLinkButton = expressQuerySelector<HTMLElement>(document, ".technical-share-link-button", false);
	const discoverAdvantages = expressQuerySelector<HTMLElement>(document, ".technical-discover-advantages", true);
	const collapsables = expressQuerySelectorAll<HTMLElement>(document, ".technical-faq-collapsable");
	const infoPageHeaderSection = expressQuerySelector<HTMLElement>(
		document,
		".technical-info-page-header-section",
		false,
	);

	const shareData = {
		title: shareLinkButton ? shareLinkButton.dataset.title : "",
		text: shareLinkButton ? shareLinkButton.dataset.text : "",
	};

	// navigator.canShare method not supported on all browsers
	// https://developer.mozilla.org/en-US/docs/Web/API/Navigator/canShare
	if (shareLinkButton)
		shareLinkButton.classList.toggle(
			"o-info-page-header__button-share--inactive",
			navigator["canShare"] ? !navigator["canShare"](shareData) : true,
		);

	const sharePersonalLink = (nativeSharing: boolean) => {
		const linkElText = linkEl.innerHTML;
		if (nativeSharing) {
			trackMgmEvent("MGMLinkShared");
			navigator.share(shareData);
			return;
		}

		const linkToolTipEl = expressQuerySelector<HTMLInputElement>(document, ".technical-link-copied", true);
		const tooltipComponent = initTooltip({
			containerEl: linkToolTipEl,
			buttonEl: null,
		});
		navigator.clipboard.writeText(linkElText).then(
			() => {
				trackMgmEvent("MGMLinkCopied");

				// show tooltip
				tooltipComponent.openToolTip();
				setTimeout(() => {
					tooltipComponent.closeToolTip();
				}, 5000);

				// select text
				if (window.getSelection) {
					const selection = window.getSelection();
					const range = document.createRange();
					range.selectNodeContents(linkEl);
					selection.removeAllRanges();
					selection.addRange(range);
					return;
				}

				const documentBody = <any>document.body;
				if (!documentBody.createTextRange) {
					const range = documentBody.createTextRange();
					range.moveToElementText(linkEl);
					range.select();
				}
			},
			() => {
				throw new Error("Copy to clipboard failed");
			},
		);
	};

	if (shareLinkButton) shareLinkButton.addEventListener("click", (_) => sharePersonalLink(true));
	if (shareLinkEL) shareLinkEL.addEventListener("click", (_) => sharePersonalLink(false));
	discoverAdvantages.addEventListener("click", (_) => {
		const advantages = expressQuerySelector(document, ".technical-advantages", false);
		let elementToScrollTo = advantages ? advantages : undefined;
		if (!elementToScrollTo) {
			const sections = expressQuerySelectorAll<HTMLElement>(document, ".m-section");
			const filterdSections = sections.splice(sections.indexOf(infoPageHeaderSection) + 1);
			elementToScrollTo = filterdSections[0];
		}

		if (elementToScrollTo) elementToScrollTo.scrollIntoView({ behavior: "smooth" });
	});
	collapsables.forEach((x) =>
		createCollapsable(x, { titleElSelector: ".m-collapsable__title", scrollIntoViewAfterOpen: false }),
	);
});
